<template>
  <div @click="$router.push('/myteam')" data-vs-button="toMyTeam">
    <div class="flex text-zt-primary-600 p-2 text-lg">
      <zt-icon name="my-team-horizontal" />
      <p class="pl-2">{{ $t('message.dashboard.myTeam') }}</p>
    </div>
    <div :class="{'flex justify-center': !dashboard, 'flex flex-col align-center': dashboard}">
      <div class="graphic-size p-2">
        <communitySVG />
      </div>
      <div class="px-4 text-center">
        <h2 class="text-3xl font-bold">{{ countTeamData }}</h2>
        <p class="text-xl">{{ $t('message.dashboard.members') }}</p>
      </div>
    </div>

    <div class="flex justify-end text-zt-primary-200 p-4 text-md">
      <p class="pl-2">{{ $t('message.dashboard.seeMembers') }}</p>
      <zt-icon name="angle-right" />
    </div>
  </div>
</template>

<script>
import communitySVG from '@/components/commons/Illustrations/graphicSVG/communitySVG'
export default {
  name: "DirectTeam",
  components: {
    communitySVG
  },
  props: {
    countTeamData: Number,
    dashboard:Boolean
  }
}
</script>

<style lang="scss" scoped></style>